import React, { Component } from 'react';

export default class Java extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="generate-java">
        Component content: generate/Java
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/generate/Java.js